/// <reference path="../../index.d.ts" />
import * as moment from 'moment';

import { BASE_DATE_FORMAT } from '../../../shared/constants';
//@ts-ignore
import * as fundspackage from '../../source/js/fundspackage-api';


const fundsApi = {
	package: fundspackage as typeof fundspackageApi,
	cashManagementSystemService: {
		client: new fundspackage.CashManagementSystemServiceClient() as CashManagementSystemServiceClient,
		fetchCashManagementSystems: () => {
			return new Promise<Array<CashManagementSystem>>(resolve => {
				fundsApi.cashManagementSystemService.client.getCashManagementSystems(result => {
					resolve(result);
				});
			});
		},
	},
	fundsRegisterService: {
		client: new fundspackage.FundsRegisterServiceClient() as FundsRegisterServiceClient,
		fetchFundsRegisters: () => {
			return new Promise<Array<FundsRegister>>(resolve => {
				const dateStart = moment().subtract(1, 'quarter').format(BASE_DATE_FORMAT);
				const dateEnd = moment().format(BASE_DATE_FORMAT);
				fundsApi.fundsRegisterService.client.getFundsRegisterStatistics(dateStart, dateEnd, result => {
					const fundsRegisters = result.map(frs => frs.FundsRegister);

					resolve(fundsRegisters);
				});
			});
		},
	},
};

export default fundsApi;
